module.exports = __webpack_public_path__ + "media/images/pic/labels/b2_2-b427799b1bef56a85dc4a956af88ad72.png";